<template>
  <div
    class="d-flex flex-column align-items-center justify-content-center flex-grow-1"
  >
    <div class="text-center">
      <font-awesome-icon
        :icon="icon"
        size="3x"
        class="mb-3 text-secondary"
      />
      <p class="mb-4 text-secondary">
        {{ message }}
      </p>
      <slot name="actions"></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: "EmptyState",
    props: {
      icon: {
        type: Array,
        default: () => ["far", "face-confused"],
      },
      message: {
        type: String,
        required: true,
      },
    },
  };
</script>
